import Skeleton from "../Skeleton/Skeleton";

const NewsItemSkeleton = () => {

    return (<div className="d-flex f-column p-16">
        <div className="d-flex f-row aic">
            <Skeleton height="32px" width="32px" borderRadius="23px"/>
            <Skeleton height="12px" width="160px" borderRadius="23px" className={"ml-8"}/>

            
            </div>

            <div className="d-flex f-row jcsb mt-12">
                <div className="d-flex f-column">
                    <Skeleton width="200px" height="12px" borderRadius="12px" className={"mt-8"}/>
                    <Skeleton width="200px" height="12px" borderRadius="12px"className={"mt-8"}/>
                    <Skeleton width="200px" height="12px" borderRadius="12px"className={"mt-8"}/>
                    <Skeleton width="150px" height="12px" borderRadius="12px"className={"mt-8"}/>
                </div>
                <Skeleton height="104px" width="104px" borderRadius="12px"/>
            </div>
    </div>)
}
export default NewsItemSkeleton;